var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"basic-layout"}},[_c('div',{staticClass:"layout-container"},[_c('img',{attrs:{"id":"logo","aria-hidden":true,"src":require("../assets/Logo@2x.png")}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }